"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextMedia = void 0;
var _react = _interopRequireDefault(require("react"));
var _useVideoModal = require("b2b-components/hooks/useVideoModal");
var _useVideoThumbnail = require("b2b-components/hooks/useVideoThumbnail");
var _Modal = require("b2b-components/theme/components/Modal");
var _Video = require("b2b-components/theme/components/Video");
var _VideoPlay = require("b2b-components/theme/components/VideoPlay");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Content = require("./Content");
var _ = require("./");
require("./TextMedia.scss");
const TextMedia = _ref => {
  let {
    className,
    htmlText,
    imageCaption,
    imageUrl,
    videoUrl,
    imagePosition = _.TEXT_MEDIA_IMAGE_POSITION.default
  } = _ref;
  const videoThumbnailUrl = (0, _useVideoThumbnail.useVideoThumbnail)(videoUrl);
  const {
    isVideoModalOpened,
    onVideoModalClose,
    onVideoPlayClick
  } = (0, _useVideoModal.useVideoModal)();
  if (!(htmlText || imageUrl || videoThumbnailUrl)) {
    return null;
  }
  const hasImagePosition = !!htmlText && imagePosition !== _.TEXT_MEDIA_IMAGE_POSITION.default;
  const rootClassName = (0, _classnames.default)('cds-cms-TextMedia', {
    [`cds-cms-TextMedia--ImagePosition${(0, _upperCase.upperCaseFirst)(imagePosition || '')}`]: hasImagePosition
  }, className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, htmlText && !hasImagePosition && /*#__PURE__*/_react.default.createElement(_Content.Content, {
    text: htmlText
  }), (!!imageUrl || !!videoThumbnailUrl) && /*#__PURE__*/_react.default.createElement("figure", {
    className: "cds-cms-TextMedia-Figure"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-cms-TextMedia-FigureBody"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: imageCaption || '',
    className: "cds-cms-TextMedia-FigureImage",
    src: imageUrl || videoThumbnailUrl
  }), videoUrl && /*#__PURE__*/_react.default.createElement(_VideoPlay.VideoPlay, {
    onClick: onVideoPlayClick
  })), imageCaption && /*#__PURE__*/_react.default.createElement("figcaption", {
    className: "cds-cms-TextMedia-FigureCaption"
  }, imageCaption)), htmlText && hasImagePosition && /*#__PURE__*/_react.default.createElement(_Content.Content, {
    text: htmlText
  })), videoUrl && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    content: () => /*#__PURE__*/_react.default.createElement(_Video.Video, {
      videoUrl: videoUrl
    }),
    isOpen: isVideoModalOpened,
    onCloseModal: onVideoModalClose,
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.TextMedia = TextMedia;
//# sourceMappingURL=TextMedia.js.map